import tools from '@/utils/tools';

//获取菜单接口
const getMenu = async function(params,that){
  var url = "/backend/setting/getMenu.html"
  const res = await tools.post(url,params,that);
  return res
}

//根据关键词搜索地址接口
const getAddressList = async function(params,that){
  var url = "/backend/common/getAddressList.html"
  const res = await tools.post(url,params,that);
  return res
}

//根据地址获取经纬度接口
const addressGetLanAndLng = async function(params,that){
  var url = "/backend/common/addressGetLanAndLng.html"
  const res = await tools.post(url,params,that);
  return res
}

//根据经纬度获取地址接口
const lanAndLngGetAddress = async function(params,that){
  var url = "/backend/common/lanAndLngGetAddress.html"
  const res = await tools.post(url,params,that);
  return res
}



const commonFunction = {
  getMenu,
  getAddressList,
  addressGetLanAndLng,
  lanAndLngGetAddress,
}

export default commonFunction;


// WEBPACK FOOTER //
// ./src/api/common.js